import { Box } from "@mui/material";
import { DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { maxRollingPeriodValue, RollingPeriodSectionProps, useRollingPeriodSection } from "./RollingPeriodSection.hooks.ts";
import { useRollingPeriodSectionStyles } from "./RollingPeriodSection.styles.ts";

function RollingPeriodSection(props: RollingPeriodSectionProps) {
    const { translateString } = useTranslation();
    const { draft, directionOptions, unitOptions, onValueChange, onDirectionChange, onUnitChange } = useRollingPeriodSection(props);
    const styles = useRollingPeriodSectionStyles(!!props.value.rollingPeriod);

    return (
        <Box sx={styles.row}>
            <Box sx={styles.direction}>
                <DotLegalSelect
                    label={""}
                    selectedItem={draft.direction.toString()}
                    options={directionOptions}
                    onChange={onDirectionChange}
                    noOptionsLabel={translateString("noOptions")}
                    // Where only past dates make sense, the direction is shown but cannot change
                    disabled={props.hideFutureDates}
                    disableClearable
                    disableSearch
                    noMargin
                />
            </Box>
            <Box sx={styles.value}>
                <DotLegalTextField
                    label={""}
                    value={draft.value}
                    onlyNumber={"integer"}
                    minNumberValue={1}
                    maxNumberValue={maxRollingPeriodValue}
                    debounce={false}
                    noMargin
                    onChange={onValueChange}
                />
            </Box>
            <Box sx={styles.unit}>
                <DotLegalSelect
                    label={""}
                    selectedItem={draft.unit.toString()}
                    options={unitOptions}
                    onChange={onUnitChange}
                    placeholder={translateString("unit")}
                    noOptionsLabel={translateString("noOptions")}
                    disableClearable
                    disableSearch
                    noMargin
                />
            </Box>
        </Box>
    );
}

export default RollingPeriodSection;
